import * as paths from 'paths';
import * as LayoutComponents from './Components';

export const onboardingRoutes = [
  { path: paths.onboardingProfile, component: LayoutComponents.OnboardingProfileLayout },
  { path: paths.onboardingFollows, component: LayoutComponents.OnboardingFollowsLayout },
  { path: paths.onboardingCreate, component: LayoutComponents.OnboardingCreateLayout },
  { path: paths.onboardingIdentity, component: LayoutComponents.OnboardingIdentityLayout },
  { path: paths.onboardingSocials, component: LayoutComponents.OnboardingSocialsLayout },
];
